<template>
  <div class="group-wrapper">
    <template v-if="tickets && tickets.length">
      <div class="found-title">{{ 'd_ws_search_found' | translate({count: tickets.length}) }}</div>
      <div class="found-body">
        <Ticket
          v-for="ticketInner in tickets"
          :key="ticketInner.id"
          :ticket="ticketInner"
          @ticketClick="onClick"
        />
      </div>
    </template>
    <div
      v-else
      class="message"
    >
      {{ 'd_ws_search_empty' | translate }}
    </div>
  </div>
</template>

<script>

import Ticket from './Ticket'

export default {
  components: {
    Ticket
  },
  props: ['tickets'],
  methods: {
    onClick(params) {
      this.$emit('ticketClick', params)
    }
  }
}
</script>

<style lang="scss" scoped>
  .group-wrapper {
    height: 100%;
  }
  .message {
    text-align: center;
    padding: 32px 16px;
    font-weight: 300;
    line-height: 150%;
    color: var(--label-secondary);
    font-feature-settings: 'ss02' on;
  }
  .found-title {
    color: var(--label-secondary);
    font-weight: 300;
    font-size: 16px;
    line-height: 150%;
    padding: 16px;
    border-bottom: 3px dotted var(--label-quarternary);
  }

  @media (max-width: 425px) {
    .message {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
